<vl-data-table class="aeg-datatable" :mod-zebra="!emptyState || loading"
               :mod-hover="!emptyState || loading">
    <thead class="aeg-datatable-header">
    <tr>
        <th>Aangemaakt</th>
        <th>Service</th>
        <th>Aanpassing</th>
    </tr>
    </thead>
    <tbody>
    <tr v-if="loading">
        <td colspan="3">
            <div class="aeg-datatable__loading">
                <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."/>
            </div>
        </td>
    </tr>
    <tr v-else-if="emptyState">
        <td colspan="3">
            <div class="aeg-datatable__empty">
                Er zijn geen wijzigingen gevonden voor deze actor.
            </div>
        </td>
    </tr>
    <tr v-else v-for="log in logs" :key="log.actorAuditLogId">
        <td>{{ formatDateTime(log.auditDate) }}</td>
        <td>{{ log.athumiService }}</td>
        <td><pre>{{ formatChanges(log.changes) }}</pre></td>
    </tr>
    </tbody>
</vl-data-table>

